import React from "react";
import styles from "./Sidebar.module.css";
import { Link, useRouterState, useNavigate } from "@tanstack/react-router";
import { NavItem } from "@pages/VendingMachinePage/ShopLayout";

interface SidebarShopProps {
  navItems: NavItem[];
}

export const SidebarShop: React.FC<SidebarShopProps> = ({ navItems }) => {
  const { location } = useRouterState();
  const navigate = useNavigate();
  const currentPath = location.pathname;

  const handleExit = () => {
    navigate({ to: "/lobby" });
  };

  // Определяем текущий активный тип страницы на основе path
  const determineActiveItem = (path: string, currentPath: string): boolean => {
    // Если точное совпадение
    if (path === currentPath) {
      return true;
    }
    
    // Для главной страницы только точное совпадение
    if (path === "/shop" && currentPath !== "/shop") {
      return false;
    }
    
    const pathSegments = path.split('/').filter(Boolean);
    const currentSegments = currentPath.split('/').filter(Boolean);
    
    if (pathSegments.length <= currentSegments.length) {
      for (let i = 0; i < pathSegments.length; i++) {
        if (pathSegments[i] !== currentSegments[i]) {
          return false;
        }
      }
      return true;
    }
    
    return false;
  };

  return (
    <div className={styles.container}>
      <div className={styles.shopPops}><img src="/assets/topShopLayout.svg" alt="asd" /></div>
      <div className={styles.sidebar}>
        <div className={styles.sidebar_nav}>
          <ul className={styles.navList}>
            {navItems.map((item) => {
              const isActive = determineActiveItem(item.path, currentPath);
              return (
                <li
                  key={item.path}
                  className={`${styles.nav} ${isActive ? styles.navLinkActive : ""}`}
                >
                  <Link to={item.path} className={styles.navLink}>
                    {item.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      <button onClick={handleExit} className={styles.exitButton}>
        <p>EXIT</p>
      </button>
    </div>
  );
};
